<template>
    <div>
        <el-row style="margin-top: 30px;">
            <el-col :span="20">
                <h1 style="margin-bottom:0">Results</h1>
            </el-col>
            <el-col :span="4" :class="`text-right`">
                <quote-results-calculator :data="result.calculator" @updated="saveAndReload" />
            </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 30px;" v-loading="loading">

            <el-col :span="24">
                <div class="alert alert-success" v-if="result.alert == 'top-20-pct'">
                    This company has <b>GREAT</b> JobAdviser conversion numbers.
                </div>

                <div class="alert alert-danger" v-if="result.alert == 'bottom-20-pct'">
                    This company has <b>BAD</b> JobAdviser conversion numbers.
                </div>

                <div class="alert alert-info" v-if="result.alert == 'average'">
                    This company is <b>AVERAGE</b> in JobAdviser.
                </div>

                <div class="alert alert-danger" v-if="result.alert == 'no_data'">
                    We don't have enough JobAdviser dials on this company, use caution when quoting.
                </div>

                <div class="table-responsive my-table">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Product</th>
                                <th style="text-align: right">Universe of Drivers</th>
                                <th>Coefficient</th>
                                <th style="text-align: right">Estimated Leads</th>
                                <th v-if="result.calculator.budget" style="text-align: right">Recommended Leads</th>
                                <th v-if="result.strict_campaign_match" style="text-align: right">Spend in last 30 days</th>
                                <th style="text-align: right">Recommended Budget</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(p,id) in result.products">
                                <td><input type="checkbox" v-model="p.enabled"></input></td>
                                <td>{{ p.name }}</td>
                                <td style="text-align: right">{{ usNum(p.drivers) }}</td>
                                <td>
                                    <div class="input-group" style="width: 120px;">
                                        <input type="number" class="form-control" max="100" v-model="p.coefficient">
                                        <span class="input-group-addon">%</span>
                                    </div>
                                </td>
                                <td style="text-align: right">{{ usNum(leads_computed[id]) }}</td>
                                <td v-if="result.calculator.budget" style="text-align: right">{{ usNum(capped_leads_computed[id]) }}</td>
                                <td v-if="result.strict_campaign_match" style="text-align: right">{{ money(p.spend_last_30_days) }}</td>
                                <td style="text-align: right">{{ money(budget_computed[id]) }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr style="border-top:2px solid black">
                                <td></td>
                                <td colspan="3">Total</td>
                                <td style="text-align: right">{{ usNum(Math.round(result_computed.leads)) }}</td>
                                <td v-if="result.calculator.budget" style="text-align: right">{{ usNum(Math.round(result_computed.capped_leads)) }}</td>
                                <td v-if="result.strict_campaign_match"></td>
                                <td style="text-align: right">{{ money(result_computed.budget) }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="3">Estimated Hires (1 in 300 MC, 1 in 50 all others)</td>
                                <td style="text-align: right">{{ usNum(Math.round(result_computed.hires)) }}</td>
                                <td v-if="result.calculator.budget" style="text-align: right">{{ usNum(Math.round(result_computed.capped_hires)) }}</td>
                                <td v-if="result.strict_campaign_match"></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-form-item>
                    <btn :click="saveResults" cssClass="btn btn-primary btn-lg">Save Results</btn>
                </el-form-item>
            </el-col>
        </el-row>
    </div>

</template>

<script>
import QuoteResultsCalculator from './dialogs/quote-results-calculator';

export default {
    props: [
        'quote_id',
        'refresh_index',
        'hiring_area_map_url'
    ],
    components: { QuoteResultsCalculator },
    data() {
        return {
            loading: false,
            result: {
                products: [],
                calculator: {
                    budget: null,
                    mc_cap: null,
                },
            }
        };
    },
    watch: {
        refresh_index() {
            this.getResults();
        }
    },
    computed: {
        result_computed() {
            let productsWithId = _.map(this.result.products, (p, id) => { p['array_pos'] = id; return p; });
            let enabledProducts = _.filter(productsWithId, (p) => p.enabled);
            let leads = _.map(enabledProducts, p => { return {is_mc: p.name == 'Multi-Carrier', leads: parseFloat(this.leads_computed[p.array_pos]), capped_leads: parseFloat(this.capped_leads_computed[p.array_pos]) }});

            let mcLeads = _.sum(_.map(_.filter(leads, (p) => p.is_mc), p => p.leads));
            let directLeads = _.sum(_.map(_.filter(leads, (p) => !p.is_mc), p => p.leads));

            let cappedMcLeads = _.sum(_.map(_.filter(leads, (p) => p.is_mc), p => p.capped_leads));
            let cappedDirectLeads = _.sum(_.map(_.filter(leads, (p) => !p.is_mc), p => p.capped_leads));

            return {
                leads: _.sum(_.map(enabledProducts, (p, id) => parseFloat(this.leads_computed[p.array_pos]))),
                capped_leads: _.sum(_.map(enabledProducts, (p, id) => parseFloat(this.capped_leads_computed[p.array_pos]))),
                budget: _.sum(_.map(enabledProducts, (p, id) => parseFloat(this.budget_computed[p.array_pos]))),
                hires: Math.floor(mcLeads / 300) + Math.floor(directLeads / 50),
                capped_hires: Math.floor(cappedMcLeads / 300) + Math.floor(cappedDirectLeads / 50),
            }
        },
        leads_computed() {
            return _.map(this.result.products, (p) => p.leads = Math.round(p.coefficient * p.drivers * 0.01));
        },
        capped_leads_computed() {
            let mc = _.find(this.result.products, ['name', 'Multi-Carrier']);
            let jb = _.find(this.result.products, ['name', 'Job Board']);
            let ja = _.find(this.result.products, ['name', 'Job Adviser']);
            let cpl = _.map(this.result.products, (p) => parseFloat(p.drivers) ? (parseFloat(p.total_budget) / parseFloat(p.drivers)) : 0);
            let leads = _.map(this.result.products, (p) => Math.round(p.coefficient * p.drivers * 0.01));
            let result = _.map(this.result.products, (p) => 0);
            if (this.result.calculator.budget) {
                let budget = this.result.calculator.budget;
                if (mc) {
                    result[mc.array_pos] = Math.min(leads[mc.array_pos], Math.floor(cpl[mc.array_pos] ? (budget * (this.result.calculator.mc_cap ? this.result.calculator.mc_cap / 100 : 0.5) / cpl[mc.array_pos]) : 0));
                    budget = budget - result[mc.array_pos] * cpl[mc.array_pos];
                }
                if (jb) {
                    result[jb.array_pos] = Math.min(leads[jb.array_pos], Math.floor(cpl[jb.array_pos] ? (budget / cpl[jb.array_pos]) : 0));
                    budget = budget - result[jb.array_pos] * cpl[jb.array_pos];
                }
                if (ja) {
                    result[ja.array_pos] = Math.min(leads[ja.array_pos], Math.floor(cpl[ja.array_pos] ? (budget / cpl[ja.array_pos]) : 0));
                    budget = budget - result[ja.array_pos] * cpl[ja.array_pos];
                }
                while (mc && budget > cpl[mc.array_pos] && leads[mc.array_pos] > result[mc.array_pos]) {
                    result[mc.array_pos]++;
                    budget -= cpl[mc.array_pos];
                }
            } 
            _.forEach(this.result.products, (p) => p.capped_leads = result[p.array_pos]);
            return result;
        },
        budget_computed() {
            let cpl = _.map(this.result.products, (p) => parseFloat(p.drivers) ? (parseFloat(p.total_budget) / parseFloat(p.drivers)) : 0);
            return _.map(this.result.calculator.budget ? this.capped_leads_computed : this.leads_computed, (p, array_pos) => this.result.products[array_pos].budget = p * cpl[array_pos]);
        }
    },
    methods: {
        getResults() {
            this.loading = true;
            return axios.get(url(`admin/quotes/${this.quote_id}/results`))
                .then(response => {
                    this.result = response.data;
                    this.loading = false;
                });
        },
        saveResults() {
            this.loading = true;
            return axios.post(url(`admin/quotes/${this.quote_id}/results`), {
                    products: this.result.products,
                    calculator: this.result.calculator,
                }).then(response => {
                    return this.getResults();
                }).then(response => {
                    this.$confirm(
                      'Results saved! We will redirect you to the quotes list or by canceling you will stay on the current page.',
                      'Quote saved', {
                        confirmButtonText: 'Return to Quotes List',
                        cancelButtonText: 'Save & Continue'
                    })
                    .then(() => {
                        window.location.href = url(`admin/quotes/list`);
                    });
                });
        },
        saveAndReload() {
            this.loading = true;
            return axios.post(url(`admin/quotes/${this.quote_id}/results`), {
                    products: this.result.products,
                    calculator: this.result.calculator,
                }).then(response => {
                    return this.getResults();
                });
        },
    },
    mounted() {
        if (this.quote_id) {
            this.getResults();
        }
    }
}
</script>

<style>
.quote h2 {
    margin-top: 50px !important;
}
.my-table td {
  vertical-align: middle !important;
}
</style>
